module.exports = __webpack_public_path__ + "room.dfb99b6f08662be2cc87.jpg";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/room.jpg
// module id = ../../../../../client/assets/img/room.jpg
// module chunks = styles